import Icon from 'components/icon/Icon';
import ContentArea from 'components/content-area/ContentArea';
import Heading from 'components/heading/Heading';
import LinkList from 'components/link/Link';
import RichText from 'components/rich-text/RichText';

import { IContactBlock } from 'source/NFR.types';

const ContactBlock: React.FC<IContactBlock> = ({ items, onPageEditing, title, singleLink, contactText }) => (
  <div className="contact-block">
    {title && (
      <Heading onPageEditing={onPageEditing?.title}>
        {title}
        <Icon name="mail-thick" />
      </Heading>
    )}
    <ContentArea {...items} />
    {contactText && <RichText {...contactText} />}
    {singleLink?.url && <LinkList key={singleLink.url} {...singleLink} text={title} noHoverEffect={true} />}
  </div>
);

ContactBlock.displayName = 'ContactBlock';

export default ContactBlock;
